// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1sCrh","form":"styles_form__3-qSI"};